import { render, staticRenderFns } from "./Lugar.vue?vue&type=template&id=c38f3086&scoped=true&"
import script from "./Lugar.vue?vue&type=script&lang=js&"
export * from "./Lugar.vue?vue&type=script&lang=js&"
import style0 from "./Lugar.vue?vue&type=style&index=0&id=c38f3086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f3086",
  null
  
)

export default component.exports